import React from "react";

class CatalogusGebruikers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      directievoerder_active: true,
      toezichthouders_active: false,
      uitvoerders_active: false,
      gebruikers: [],
    };
    this.handleClickChange = this.handleClickChange.bind(this);
  }

  handleClickChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (name == "directievoerder_active") {
      this.setState({
        directievoerder_active: true,
        toezichthouders_active: false,
        uitvoerders_active: false,
      });
    } else if (name == "toezichthouders_active") {
      this.setState({
        toezichthouders_active: true,
        directievoerder_active: false,
        uitvoerders_active: false,
      });
    } else if (name == "uitvoerders_active") {
      this.setState({
        uitvoerders_active: true,
        directievoerder_active: false,
        toezichthouders_active: false,
      });
    }
  }

  handleEvent() {
    this.state = {
      directievoerder_active: this.state.directievoerder_active,
      toezichthouders_active: this.state.toezichthouders_active,
      uitvoerders_active: this.state.uitvoerders_active,
      gebruikers: this.props.gebruikers == false ? [] : this.props.gebruikers,
    };
  }

  async componentDidMount() {}

  render() {
    this.handleEvent();
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="catalogus-gebruikers"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Gebruikers van dit werkplan</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="modal-btn-group" style={{ paddingBottom: "6em" }}>
                <button
                  type="button"
                  onClick={this.handleClickChange}
                  name="directievoerder_active"
                  className={
                    this.state.directievoerder_active
                      ? "button-directievoerder-focus"
                      : "button-directievoerder"
                  }
                >
                  Directievoerder
                </button>
                <button
                  type="button"
                  onClick={this.handleClickChange}
                  name="toezichthouders_active"
                  className={
                    this.state.toezichthouders_active
                      ? "button-toezichthouders-focus"
                      : "button-toezichthouders"
                  }
                >
                  Toezichthouders
                </button>
                <button
                  type="button"
                  onClick={this.handleClickChange}
                  name="uitvoerders_active"
                  className={
                    this.state.uitvoerders_active
                      ? "button-uitvoerders-focus"
                      : "button-uitvoerders"
                  }
                >
                  Uitvoerders
                </button>
              </div>

              {this.state.gebruikers.data !== undefined
                ? this.state.gebruikers.data.map((user) =>
                    user.role == "Directievoerder" ? (
                      <div
                        className="gebruikers-list-directievoerder"
                        style={{
                          display: this.state.directievoerder_active
                            ? "block"
                            : "none",
                        }}
                      >
                        <div className="gebruikers-content">
                          <span className="gebruikers-ico"></span>
                          <div className="gebruikers-name">
                            {user.relationships.related_instance.name}
                          </div>
                        </div>
                      </div>
                    ) : user.role == "Toezichthouder" ? (
                      <div
                        className="gebruikers-list-toezichthouders"
                        style={{
                          display: this.state.toezichthouders_active
                            ? "block"
                            : "none",
                        }}
                      >
                        <div className="gebruikers-content">
                          <span className="gebruikers-ico"></span>
                          <div className="gebruikers-name">
                            {user.relationships.related_instance.name}
                          </div>
                        </div>
                      </div>
                    ) : user.role == "Uitvoerder" ? (
                      <div
                        className="gebruikers-list-uitvoerders"
                        style={{
                          display: this.state.uitvoerders_active
                            ? "block"
                            : "none",
                        }}
                      >
                        <div className="gebruikers-content">
                          <span className="gebruikers-ico"></span>
                          <div className="gebruikers-name">
                            {user.relationships.related_instance.name}
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )
                  )
                : ""}
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default CatalogusGebruikers;
